import React from "react";
import { ReferenceInput, required, SelectInput, SimpleForm, TextInput } from "react-admin";
import { Grid } from "@mui/material";
import { employeeRequests } from "api/employeeApi";

const PositionSaveForm = () => {
  return (
    <SimpleForm>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={6}
        >
          <TextInput
            label="Име на български език"
            source="nameBg"
            validate={required()}
          />
        </Grid>
        <Grid
          item
          xs={6}
        >
          <ReferenceInput
            source="typeId"
            reference={employeeRequests.getPositionTypesSelect()}
          >
            <SelectInput
              optionText="name"
              label="Тип позиция"
              fullWidth
              validate={required()}
            />
          </ReferenceInput>
        </Grid>
      </Grid>
    </SimpleForm>
  );
};

export default PositionSaveForm;
